import { render, staticRenderFns } from "./recover-password-modal.vue?vue&type=template&id=ced452c2"
import script from "./recover-password-modal.vue?vue&type=script&lang=js"
export * from "./recover-password-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports